module.exports = __webpack_public_path__ + "static/media/img-products-seat@3x.ae2749a9.png";